<template>
  <v-card :loading="campLoading" class="px-3 pb-3 rounded-lg" outlined>
    <v-card-title class="font-size-h6 pa-2">
      برای
      <span class="red--text mx-1">انتخاب کمپین</span>
      روی ردیف مورد نظر کلیک کنید.
    </v-card-title>

    <data-table
      :columns="columns"
      :data="data"
      :orderDir="tableProps.dir"
      :per-page="[10, 25, 50, 100, 400]"
      :translate="translate"
      class="mt-3"
      @on-table-props-changed="reloadTable"
      @row-clicked="selectRow"
    />
  </v-card>
</template>

<script>
import { debounce, SmsAxios } from "@/main";

export default {
  name: "messageList",

  data() {
    return {
      campLoading: false,
      data: {},
      campName: "",
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "تاریخ",
          name: "created_at",
          transform: ({ data }) => {
            return this.datetime(data.created_at);
          },
        },
        {
          label: "ساعت",
          name: "created_at_time",
          transform: ({ data }) => {
            return this.getTime(data.created_at);
          },
        },
        {
          label: "تعداد پیام",
          name: "text",
          transform: ({ data }) => {
            return data.messages.text.length || 0;
          },
        },
        {
          label: "مجموع پیام (صفحه)",
          name: "count",
          transform: ({ data }) => {
            return data.messages.count || "-" + " صفحه";
          },
        },
        { label: "نام کمپین", name: "messages.name", serchable: true },
      ],
      tableProps: {
        search: "",
        filters: {},
        status: "accept",
        length: 10,
        column: "id",
        dir: "desc",
      },
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
    };
  },

  created() {
    this.fetchCamps(this.tableProps);
  },

  methods: {
    fetchCamps(params = this.tableProps) {
      this.$emit("update:loading", true);
      this.campLoading = true;

      SmsAxios.get("campaign/list", {
        params,
      })
        .then(({ data }) => (this.data = data))
        .catch(({ response }) => console.log("error in res: ", response))
        .finally(() => {
          this.$emit("update:loading", false);
          this.campLoading = false;
        });
    },
    reloadTable(props) {
      debounce(() => this.fetchCamps(props), 500);
    },
    selectRow(data) {
      let arr = [];
      data.messages.text.forEach((item, i) => {
        this.$toast.clear();
        if (!item) {
          return this.$toast.warning(
            "لطفا متن/های کمپین انتخابی خود را تصحیح نمایید!",
            { timeout: 4000 },
          );
        } else if (!data.messages.title[i]) {
          return this.$toast.warning(
            "لطفا عنوان/های کمپین انتخابی خود را تصحیح نمایید!",
            { timeout: 4000 },
          );
        } else if (!(data.messages.gap[i] >= 0)) {
          return this.$toast.warning(
            "لطفا فاصله زمانی/های کمپین انتخابی خود را تصحیح نمایید!",
            { timeout: 4000 },
          );
        } else if (!data.messages.Operator || !data.messages.Operator[i]) {
          return this.$toast.warning(
            "لطفا اپراتور/های کمپین انتخابی خود را تصحیح نمایید!",
            { timeout: 4000 },
          );
        }

        arr.push({
          text: item,
          title: data.messages.title[i],
          gap: i === 0 ? 0 : data.messages.gap[i],
          type: data.messages.type ? data.messages.type[i] : null,
          operator: data.messages?.Operator ? data.messages?.Operator[i] : "",
        });
      });

      this.computedValue = arr;
      this.$emit("update:campId", data.id);

      const id = data.id;
      $("tr").css("background", "");

      $(`tr:contains("${id}")`).each(function (index, item) {
        if ($(item).find("td").eq(1).text() == id)
          $(item).css("background", "rgba(99, 0, 244, 0.28)");
      });
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      // var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");

      return !str || regex.test(str) || str.length <= 0;
    },
  },
};
</script>
